var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: {
          padding: "0 20px",
          "overflow-y": "auto",
          height: "calc(100vh - 120px)",
        },
      },
      [
        _c(
          "el-form",
          {
            ref: "sysInfoRuleForm",
            attrs: {
              model: _vm.sysInfoObj,
              rules: _vm.sysInfoObjRules,
              "label-position": "top",
              size: "small",
            },
          },
          [
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 10 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("customerManagements.messageType"),
                          prop: "msgTypeInfo",
                        },
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            on: { change: _vm.changeMsgTypeInfo },
                            model: {
                              value: _vm.sysInfoObj.msgTypeInfo,
                              callback: function ($$v) {
                                _vm.$set(_vm.sysInfoObj, "msgTypeInfo", $$v)
                              },
                              expression: "sysInfoObj.msgTypeInfo",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v(_vm._s(_vm.$t("GlobalSetObj.sysMessage"))),
                            ]),
                            _c("el-radio", { attrs: { label: 2 } }, [
                              _vm._v(
                                _vm._s(_vm.$t("GlobalSetObj.announcement"))
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 14 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("GlobalSetObj.system"),
                          prop: "systemType",
                        },
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            on: { change: _vm.handleSystemType },
                            model: {
                              value: _vm.sysInfoObj.systemType,
                              callback: function ($$v) {
                                _vm.$set(_vm.sysInfoObj, "systemType", $$v)
                              },
                              expression: "sysInfoObj.systemType",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v(_vm._s(_vm.$t("GlobalSetObj.all"))),
                            ]),
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("customerManagements.expressSystem")
                                )
                              ),
                            ]),
                            _c("el-radio", { attrs: { label: 2 } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("customerManagements.providerSystem")
                                )
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.sysInfoObj.msgTypeInfo === 1
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 10 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("customerManagements.userSide"),
                                  prop: "clientType",
                                },
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    on: { change: _vm.handleClientType },
                                    model: {
                                      value: _vm.sysInfoObj.clientType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.sysInfoObj,
                                          "clientType",
                                          $$v
                                        )
                                      },
                                      expression: "sysInfoObj.clientType",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: 0 } }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("GlobalSetObj.all"))
                                      ),
                                    ]),
                                    _c("el-radio", { attrs: { label: 1 } }, [
                                      _vm._v(_vm._s("PC")),
                                    ]),
                                    _c("el-radio", { attrs: { label: 2 } }, [
                                      _vm._v(_vm._s("APP")),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "customerManagements.notificationType"
                                  ),
                                  prop: "reminder",
                                },
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    on: { change: _vm.handleClientType },
                                    model: {
                                      value: _vm.sysInfoObj.reminder,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.sysInfoObj,
                                          "reminder",
                                          $$v
                                        )
                                      },
                                      expression: "sysInfoObj.reminder",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: 0 } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "customerManagements.weakReminder"
                                          )
                                        )
                                      ),
                                    ]),
                                    _c("el-radio", { attrs: { label: 1 } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "customerManagements.strongReminder"
                                          )
                                        )
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.sysInfoObj.systemType !== 0
                          ? _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "spareNumberPoo.receivingUser"
                                      ),
                                      prop: "receiveUser",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        on: { change: _vm.changeReceiveUser },
                                        model: {
                                          value: _vm.sysInfoObj.receiveUser,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.sysInfoObj,
                                              "receiveUser",
                                              $$v
                                            )
                                          },
                                          expression: "sysInfoObj.receiveUser",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 1 } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "spareNumberPoo.allUsers"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 0 } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "spareNumberPoo.specifiedUser"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.sysInfoObj.receiveUser !== 1
                          ? _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("basicData.StateOfOutlet"),
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          disabled: _vm.isState,
                                          placeholder: _vm.$t(
                                            "GlobalSetObj.pleaseChoose"
                                          ),
                                          clearable: "",
                                          filterable: "",
                                          multiple: "",
                                        },
                                        on: { change: _vm.changeState },
                                        model: {
                                          value: _vm.sysInfoObj.state,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.sysInfoObj,
                                              "state",
                                              $$v
                                            )
                                          },
                                          expression: "sysInfoObj.state",
                                        },
                                      },
                                      _vm._l(_vm.StateList, function (item) {
                                        return _c("el-option", {
                                          key: item.id,
                                          attrs: {
                                            label: item.label,
                                            value: item.label,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.sysInfoObj.systemType !== 1 &&
                        _vm.sysInfoObj.receiveUser !== 1
                          ? _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "customerManagements.providerSite"
                                      ),
                                      prop: "providerId",
                                    },
                                  },
                                  [
                                    _vm.sysInfoObj.systemType === 2
                                      ? _c("el-cascader", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            disabled: _vm.isProviderIdDisable,
                                            options: _vm.siteData,
                                            props: {
                                              multiple: true,
                                              checkStrictly: true,
                                            },
                                            clearable: "",
                                            filterable: "",
                                            size: "small",
                                          },
                                          on: { change: _vm.handleObj },
                                          model: {
                                            value: _vm.sysInfoObj.providerId,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.sysInfoObj,
                                                "providerId",
                                                $$v
                                              )
                                            },
                                            expression: "sysInfoObj.providerId",
                                          },
                                        })
                                      : _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              disabled: _vm.isProviderIdDisable,
                                              clearable: "",
                                              filterable: "",
                                              multiple: "",
                                              size: "small",
                                            },
                                            on: { change: _vm.handleObj },
                                            model: {
                                              value: _vm.sysInfoObj.providerId,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.sysInfoObj,
                                                  "providerId",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "sysInfoObj.providerId",
                                            },
                                          },
                                          _vm._l(
                                            _vm.siteListData,
                                            function (item) {
                                              return _c("el-option", {
                                                key: item.id,
                                                attrs: {
                                                  label: item.name,
                                                  value: item.id,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.sysInfoObj.receiveUser !== 1
                          ? _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "customerManagements.account"
                                      ),
                                      prop: "userList",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          disabled: _vm.isProviderIdDisable,
                                          placeholder: _vm.$t(
                                            "GlobalSetObj.Only10AreDisplayed"
                                          ),
                                          "remote-method": _vm.getAllUserList,
                                          clearable: "",
                                          filterable: "",
                                          multiple: "",
                                          remote: "",
                                          "reserve-keyword": "",
                                        },
                                        on: {
                                          change: _vm.changeUserList,
                                          "visible-change":
                                            _vm.handleAllUserList,
                                        },
                                        model: {
                                          value: _vm.sysInfoObj.userList,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.sysInfoObj,
                                              "userList",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "sysInfoObj.userList",
                                        },
                                      },
                                      _vm._l(_vm.accountList, function (item) {
                                        return _c("el-option", {
                                          key: item.id,
                                          attrs: {
                                            label: item.username,
                                            value: item.id,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.sysInfoObj.userList.length > 0 &&
                        _vm.sysInfoObj.systemType === 2
                          ? _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "spareNumberPoo.isFalseDeliveryWarning"
                                      ),
                                      prop: "isWarning",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "GlobalSetObj.pleaseChoose"
                                          ),
                                          clearable: "",
                                        },
                                        model: {
                                          value: _vm.sysInfoObj.isWarning,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.sysInfoObj,
                                              "isWarning",
                                              $$v
                                            )
                                          },
                                          expression: "sysInfoObj.isWarning",
                                        },
                                      },
                                      [
                                        _c("el-option", {
                                          key: "0",
                                          attrs: {
                                            label: _vm.$t("GlobalSetObj.No"),
                                            value: false,
                                          },
                                        }),
                                        _c("el-option", {
                                          key: "1",
                                          attrs: {
                                            label: _vm.$t("GlobalSetObj.yes"),
                                            value: true,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("customerManagements.headline"),
                          prop: "title",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: _vm.$t("orderDetails.pleaseInput"),
                            clearable: "",
                            maxlength: "200",
                            "show-word-limit": "",
                          },
                          model: {
                            value: _vm.sysInfoObj.title,
                            callback: function ($$v) {
                              _vm.$set(_vm.sysInfoObj, "title", $$v)
                            },
                            expression: "sysInfoObj.title",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("customerManagements.content"),
                          prop: "textarea",
                        },
                      },
                      [
                        _c("tinymce", {
                          attrs: {
                            height: 280,
                            "is-image": _vm.isImage,
                            "msg-plugin": _vm.msgPlugin,
                            placeholder:
                              _vm.$t("GlobalSetObj.pleaseInputContent") + "...",
                            toolbar: _vm.toolbar,
                          },
                          model: {
                            value: _vm.sysInfoObj.textarea,
                            callback: function ($$v) {
                              _vm.$set(_vm.sysInfoObj, "textarea", $$v)
                            },
                            expression: "sysInfoObj.textarea",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "messageFooter" },
      [
        _c(
          "el-button",
          { attrs: { size: "small" }, on: { click: _vm.clearForm } },
          [_vm._v(_vm._s(_vm.$t("GlobalSetObj.cancel")))]
        ),
        _c(
          "el-button",
          {
            attrs: { size: "small", type: "primary" },
            on: { click: _vm.confirmDialog },
          },
          [_vm._v(_vm._s(_vm.$t("GlobalSetObj.determine")) + " ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }